import { Component, OnInit, ViewChildren, ViewChild, Input, Output, QueryList, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { SecurityService } from 'src/app/shared/services/security.service';
import { FormGroup, Validators, FormControl, FormBuilder, AbstractControl } from '@angular/forms';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { ProductoService } from 'src/app/services/producto.service';
import { IProductMultipleSelection, ModalSeleccionarProductoComponent } from 'src/app/views/shared/modal-seleccionar-producto/modal-seleccionar-producto.component';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { debounceTime, filter } from 'rxjs/operators';
import { ModalVerErroresComponent } from 'src/app/views/shared/modal-ver-errores/modal-ver-errores.component';
import { MDBDatePickerComponent, ToastService, IMyOptions, LocaleService } from 'ng-uikit-pro-standard';
import { TipoDescuentoService } from 'src/app/services/tipo-descuento.service';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import gql from 'graphql-tag';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { QueryResult } from 'src/app/shared/object/queryResult.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { AuditoriaInput } from 'src/app/views/configuracion-sistema/auditoria/lista-auditoria/lista-auditoria.component';
import { DatesService } from 'src/app/shared/services/dates.service';

type MODE = 'ADD' | 'EDIT' | 'VIEW';

@Component({
  selector: 'app-modal-addedit-descuentos-topes',
  templateUrl: './modal-addedit-descuentos-topes.component.html',
  styleUrls: ['./modal-addedit-descuentos-topes.component.scss'],
  providers: [SecurityService, ValidadoresService],
})
export class ModalAddeditDescuentosTopesComponent implements OnInit {
  @Input() permiteUnidadNegocio: any = [];

  // Outputs
  @Output() onSuccess: EventEmitter<any> = new EventEmitter<any>();

  @ViewChildren(ModalSeleccionarProductoComponent) modalSeleccionarProducto: QueryList<ModalSeleccionarProductoComponent>;
  @ViewChild('agregarDescuento', { static: true }) modalAgregarDescuento: ModalDirective;
  @ViewChild(ModalVerErroresComponent, { static: true }) modalVerErrores: ModalVerErroresComponent;
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent;

  // Data &  Tmp
  private rutEmpresa: Number;
  private sucursalEmpresa: Number;
  private rutUsuario: Number;

  codigoDescuento: number = -1;
  private loading: boolean = false;
  listaDescuentos: any = [];
  listaDescuentosPage: any = [];
  paginationContext: PaginationContext = new PaginationContext();
  productosMultiplesSeleccionados: any[] = null;
  optionsTipoDescuentoAll: any = [];
  private loaded: boolean = false;

  mode: MODE;
  private log: any;
  lastIndex: number = 0;
  inputLinea: number = 9999;

  // Form
  formHeader: FormGroup;
  formDetails: FormGroup;

  // Utils
  DescProduct: any;
  EditarDesc: number = 0;
  DescProductSelect: number = 0;
  EditoDesc: number = 0;
  btnGuardarDisabled: boolean = false;
  defaultUnidadNegocio: number = null;
  currentTabs: string;
  auditoria: AuditoriaInput;

  readonly MODAL_SEL_PROD_DESCUENTO = 'MODAL_SEL_PROD_DESCUENTO';

  // getters
  get modalDescuento() {
    return this.modalSeleccionarProducto.filter((mod) => mod.origen === this.MODAL_SEL_PROD_DESCUENTO)[0];
  }

  optionsTipoDescuento: Array<any> = [
    { value: '1', label: 'Monto' },
    { value: '2', label: 'Porcentaje' },
  ];

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService,
    public validadores: ValidadoresService,
    private formValidatorsService: FormValidatorsService, //private localeService: LocaleService
    private productoService: ProductoService,
    private tipoDescuentoService: TipoDescuentoService,
    private toastrService: ToastService,
    private datesService: DatesService
  ) {
    this.log = this.clog.log('MODAL-DCTOS-MAXIMO');
  }

  ngOnInit() {
    this.rutEmpresa = this.accesolocalstorage.getRutEmpresa();
    this.sucursalEmpresa = this.accesolocalstorage.getSucursalCodigo();
    this.rutUsuario = this.accesolocalstorage.getRutUsuario();
    this.paginationContext.RecordsByPage = 10;
    this.loadTipoDescuento();
    this.createForms();
    this.formChangesSubscriptions();
  }

  trackByDetalleProductoCodigo(index: number, item: any) {
    return item && item.producto_codigo != null ? item.producto_codigo : (item && item.codigo != null ? item.codigo : index);
  }

  formChangesSubscriptions() {
    this.formDetails.get('tipoDescuento').setValue('2');

    this.formDetails
      .get('codigoProducto')
      .valueChanges.pipe(filter(Boolean))
      .subscribe((codProduct: string) => {
        this.modalDescuento.searchByCodeProduct(codProduct);
      });
  }

  show(mode: MODE) {
    this.mode = mode;
    if (mode === 'ADD') {
      this.codigoDescuento = -1;
      this.currentTabs = 'detalle';
      this.formHeader.get('fechaInicio').setValue(this.datesService.GetStartAndCurrentMonth().DateNextDay);
      this.formHeader.get('fechaFin').setValue(this.datesService.GetStartAndCurrentMonth().lastDate)

    } else {
      this.EditoDesc = 1;
      // this.disabledContent = true
      // this.disabledContent = false // LO DEJO ASÍ YA QUE CREO QUE SE ITERARÁ SOBRE ESTO.
    }

    this.formDetails.get('tipoDescuento').setValue('2');

    this.modalAgregarDescuento.show();
  }

  verDetalle() {
    this.currentTabs = "detalle";
  }
  verAuditoria() {
    this.auditoria = {
      codigoEntidad: this.codigoDescuento,
      entidad: 'DESCUENTO MAXIMO'
    };
    this.currentTabs = "auditoria";
  }

  load(rut_empresa: number, sucursal_codigo: number, descuento_codigo: number, allowEdit: boolean = true) {
    this.currentTabs = 'detalle';
    this.mode = allowEdit ? 'EDIT' : 'VIEW';
    this.codigoDescuento = descuento_codigo;
    const _variables = {
      rut_empresa,
      sucursal_codigo,
      descuento_codigo,
    };

    this.loaded = false;
    this.loading = true;

    this.log('_variables');
    this.log(JSON.stringify(_variables));

    // fecha_inicio
    // fecha_termino
    const self = this;
    this.gqlclient.query(
      {
        query: gql`
          query ($rut_empresa: Decimal, $sucursal_codigo: Decimal, $descuento_codigo: Decimal) {
            descuento_maximo {
              obtenerSegunId(entidad: { codigo: $descuento_codigo, rut_empresa: $rut_empresa, sucursal_codigo: $sucursal_codigo }) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  codigo
                  sucursal_codigo
                  rut_empresa
                  fecha_inicio
                  fecha_termino
                  activado
                  descripcion
                }
              }
            }
            descuento_maximo_producto {
              obtenerSegunFiltro(filtro: { exacto: { rut_empresa: $rut_empresa, sucursal_codigo: $sucursal_codigo, descuento_codigo: $descuento_codigo, producto_codigo: -1 } }) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  totalPaginas
                  totalRegistros
                  registros {
                    sucursal_codigo
                    rut_empresa
                    producto_codigo
                    es_porcentaje
                    monto_descuento
                    precio_fijo
                    nombreProducto
                    descuento_codigo
                    skuProducto
                    precio_unitario
                  }
                }
              }
            }
          }
        `,
        variables: _variables,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        // Descuento
        const { respuesta: descuento } = response.data.descuento_maximo.obtenerSegunId;
        self.formHeader.get('descripcion').setValue(descuento.descripcion);
        self.formHeader.get('activo').setValue(descuento.activado);
        self.formHeader.get('fechaInicio').setValue(descuento.fecha_inicio);
        self.formHeader.get('fechaFin').setValue(descuento.fecha_termino);

        // Header
        const { respuesta: respHeader } = response.data.descuento_maximo_producto.obtenerSegunFiltro;
        const { registros: headerData } = respHeader;
        // self.formHeader.get('buscarPor').setValue(0)//: [this.TIPO_CLIENTE, [Validators.required]],
        // self.formHeader.get('clienteOrTipos').setValue(0)//: [null, [Validators.required]],

        // self.clientesSeleccionadosFormatted = self.clientesSeleccionados.map(p => p.nombre).join(', ')

        const { mensajes, respuesta: respDetalles } = response.data.descuento_maximo_producto.obtenerSegunFiltro;
        const { registros: productsData, paginaActual, totalPaginas, totalRegistros } = respDetalles;

        // Products
        self.listaDescuentos = productsData.map((producto, index) => ({
          producto_codigo: producto.producto_codigo,
          empresa_rut: producto.rut_empresa,
          sku: producto.skuProducto,
          descripcion: producto.nombreProducto,
          tipoDescuento: producto.es_porcentaje ? '2' : '1',
          tipoDescuentoGlosa: self.optionsTipoDescuentoAll.filter((p) => p.value === (producto.es_porcentaje ? '2' : '1'))[0].label,
          monto: producto.es_porcentaje ? 0 : producto.precio_fijo,
          porcentaje: producto.es_porcentaje ? producto.monto_descuento : 0,
          precio_unitario: producto.precio_unitario,
          precioFinal: self.calcularPrecioFinal(producto),
          descuento: self.calcularDescuento(producto.precio_unitario, producto.es_porcentaje ? producto.monto_descuento : producto.precio_fijo, producto.es_porcentaje),
          index,
        }));

        self.paginationContext.CurrentPage = 1;
        self.renderItemDescuento();

        self.show(self.mode);
      }
    );
  }

  reset() {
    if (this.mode === 'EDIT' || this.mode === 'VIEW') {

      this.lastIndex = 0;
    }

    this.resetFormHeader();
    this.resetFormDetails();
    this.resetListaDescuentos();
  }

  resetFormHeader() {
    this.formHeader.reset();
    this.formHeader.markAsPristine();
    this.formHeader.markAsUntouched();

    this.formHeader.get('descripcion').setValue('');
    this.formHeader.get('activo').setValue(true);
    this.formHeader.get('fechaInicio').setValue('');
    this.formHeader.get('fechaFin').setValue('');
    this.formDetails.get('montoOrPorcentaje').setValue('');

    this.productosMultiplesSeleccionados = null;
  }

  resetFormDetails() {
    this.formDetails.reset();
    this.formDetails.markAsPristine();
    this.formDetails.markAsUntouched();

    this.formDetails.get('codigoProducto').setValue('');
    this.formDetails.get('tipoDescuento').setValue(null);
    this.formDetails.get('montoOrPorcentaje').setValue('');

    this.productosMultiplesSeleccionados = null;
  }

  resetListaDescuentos() {
    this.paginationContext.CurrentPage = 1;
    this.listaDescuentos = [];
    this.listaDescuentosPage = [];
  }

  loadTipoDescuento() {
    this.optionsTipoDescuentoAll = this.tipoDescuentoService.GetTiposDescuento();
  }

  createForms() {
    const { DateNextDay, lastDate } = this.datesService.GetStartAndCurrentMonth()

    this.formHeader = this.fb.group({
      descripcion: ['', [Validators.required]],
      activo: [true],
      fechaInicio: [DateNextDay, [Validators.required]],
      fechaFin: [lastDate, [Validators.required]],
    });
    this.formDetails = this.fb.group({
      codigoProducto: ['', [Validators.required, Validators.min(1)]],
      tipoDescuento: ['2', [Validators.required]],
      montoOrPorcentaje: [null, [Validators.required, Validators.min(1), this.descuentoValidator()]], // TODO: Custom validator para toogle monto/porcentaje
    });
  }

  descuentoValidator() {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (control.value !== null && control.value !== undefined) {
        const valueWithDot = control.value.replace(',', '.');
        const descuento = parseFloat(valueWithDot);
        if (control.value != '' && isNaN(descuento)) {
          return { descuentoInvalido: { value: control.value } };
        } else {
          const descuentoStr = descuento.toString();
          const puntoDecimalPos = descuentoStr.indexOf('.');
          if (puntoDecimalPos !== -1 && descuentoStr.length - puntoDecimalPos > 3) {
            return { descuentoInvalido: { value: control.value } };
          }
        }
      }
      return null; // No hay error de validación
    };
  }

  //habilitar edicion del input
  EditarProducto(dcto, index) {
    this.DescProductSelect = dcto.producto_codigo;
    this.inputLinea = index;
    this.EditoDesc = 0;
  }

  ProcesoEditarPedidoCompletado() {
    //* SE REALIZA BUSQUEDA DEL PRODUCTO SELECCIONADO PARA MODIFICAR SU PORCENTAJE
    this.listaDescuentosPage.map((item) => {
      if (item.producto_codigo === this.DescProductSelect) {
        //* SI PORCENTAJE CONTIENE "," SE REEMPLAZA POR "."

        if (typeof item.porcentaje === 'string') {
          if (item.porcentaje.includes(',')) {
            item.porcentaje = item.porcentaje.replace(',', '.');
          }
        }
      }
    });
    this.EditoDesc = 1;
    this.inputLinea = 9999;
  }

  //*FIN EDICION DE PORCENTAJE

  validateExistenceInList({ sku }) {
    return this.listaDescuentos.filter((p) => p.sku === sku).length === 0;
  }

  createPayloadProducto(producto) {
    return {
      producto_codigo: producto.codigo,
      empresa_rut: producto.empresa_rut,
      sku: producto.sku,
      descripcion: producto.descripcion,
      tipoDescuento: this.formDetails.get('tipoDescuento').value,
      tipoDescuentoGlosa: this.optionsTipoDescuento.filter((opt) => Number(opt.value) === Number(this.formDetails.get('tipoDescuento').value))[0].label,
      monto: this.formDetails.get('tipoDescuento').value === '1' ? Number(this.formDetails.get('montoOrPorcentaje').value) : 0,
      porcentaje: this.formDetails.get('tipoDescuento').value === '2' ? Number(this.formDetails.get('montoOrPorcentaje').value.replace(',', '.')) : 0,
      precio_unitario: producto.precio_unitario,
      precioFinal: this.calcularPrecioFinal(producto),
      descuento: this.calcularDescuento(producto.precio_unitario, Number(this.formDetails.get('montoOrPorcentaje').value), this.formDetails.get('tipoDescuento').value),
      index: this.listaDescuentos.length + 1,
    };
  }

  async agregarItemDescuento() {
    if (this.productosMultiplesSeleccionados !== null && this.productosMultiplesSeleccionados.length > 1) {
      this.setCodigoProductoValidators('REMOVE');
    } else {
      this.setCodigoProductoValidators('ADD');
    }

    this.formValidatorsService.validateAllFormFields(this.formDetails);

    const fechaInicio = this.formHeader.get('fechaInicio').value;
    const fechaFin = this.formHeader.get('fechaFin').value;

    if (fechaInicio == null || fechaInicio === '') {
      this.toastrService.warning('Ingrese Fecha de inicio');
      return;
    }

    if (fechaFin == null || fechaFin === '') {
      this.toastrService.warning('Ingrese Fecha de termino');
      return;
    }

    if (this.productosMultiplesSeleccionados !== null && this.productosMultiplesSeleccionados.length === 0) {
      this.toastrService.warning('Ingrese producto(s)');
      return;
    }

    if (this.optionsTipoDescuento.length === 1) {
      this.formDetails.get('tipoDescuento').setValue(this.optionsTipoDescuento[0].value);
    }

    if (!this.formDetails.valid) {
      this.toastrService.warning('Favor complete los datos requeridos');
      return;
    }

    if (this.productosMultiplesSeleccionados !== null) {
      var DescProduct: any;
      DescProduct = await this.validarExisteProductoEnDescuento(this.productosMultiplesSeleccionados);
      console.log('Función externa completada. Continuando con la función principal');
      if (DescProduct.listaProductos == true) {
        DescProduct.registros.forEach((p) => {
          const findError = DescProduct.mensajes.some((x) => x.tipo === 'ERROR');
          if (findError) {
            //Mensaje modal de error
            this.modalVerErrores.loadAndShow(DescProduct.mensajes);
            // this.toastrService.warning(`Producto sku ${producto.sku} del cliente ${rutClienteFormateado} se encuentra en un descuento activo`);
            return;
          }
        });
        return;
      }
      // }

      const productoUnico: boolean = this.productosMultiplesSeleccionados.length === 1;
      let productosAgregadosCount: number = 0;
      // this.productosMultiplesSeleccionados.forEach(producto => {
      for (let i = 0; i < this.productosMultiplesSeleccionados.length; i++) {
        const producto = this.productosMultiplesSeleccionados[i];

        // Validar existencia en lista
        if (!this.validateExistenceInList(producto)) {
          this.toastrService.warning(`Producto sku ${producto.sku} ya se encuentra en lista`);
          if (productoUnico) return;
          else continue;
        }

        // Validar unidad de negocio
        if (this.permiteUnidadNegocio)
          if (!this.validateUnidadNegocioNewProduct(producto)) {
            this.toastrService.warning(`Producto sku ${producto.sku} debe tener la misma unidad de negocio`);
            return;
          }

        // nuevo item
        const newDcto: any = this.createPayloadProducto(producto);

        this.listaDescuentos.push(newDcto);
        this.lastIndex++;
        productosAgregadosCount++;
        this.fixAndDisableUnidadNegocio(producto);
      }
      if (productoUnico) this.toastrService.success(`Producto agregado`);
      else if (productosAgregadosCount > 0) this.toastrService.success(`${productosAgregadosCount} productos agregados`);
    }
    this.renderItemDescuento();
    this.resetFormDetails();
    this.formDetails.reset();
    this.formDetails.get('tipoDescuento').setValue('2');
    this.EditoDesc = 1;
    this.productosMultiplesSeleccionados = null;
    this.log(this.listaDescuentos);
  }

  async validarExisteProductoEnDescuento(producto) {
    const a = await new Promise((resolve) => {
      setTimeout(() => {
        const entidad = producto.map((x) => {
          const params = {
            descuento_codigo: this.codigoDescuento,
            producto_codigo: x.codigo,
            rut_empresa: x.empresa_rut,
            descripcion: x.descripcion,
            // tipoDescuento: this.formDetails.get('tipoDescuento').value,
            // tipoDescuentoGlosa: this.optionsTipoDescuento.filter((opt) => Number(opt.value) === Number(this.formDetails.get('tipoDescuento').value))[0].label,
            // monto: this.formDetails.get('tipoDescuento').value === '1' ? Number(this.formDetails.get('montoOrPorcentaje').value) : 0,
            // porcentaje: this.formDetails.get('tipoDescuento').value === '2' ? Number(this.formDetails.get('montoOrPorcentaje').value.replace(',', '.')) : 0,
            // index: this.listaDescuentos.length + 1,
            fecha_inicio: this.formHeader.get('fechaInicio').value,
            fecha_termino: this.formHeader.get('fechaFin').value,
          };
          return params;
        });

        const inputParams = {
          entidad,
        };

        this.tipoDescuentoService.obtenerDescuentoMaximoProducto(inputParams, ({ mensajes, respuesta }) => {
          const ok = respuesta !== null && respuesta !== undefined;
          if (!ok) {
            this.messageRendererService.showErrors(mensajes);
            return false;
          }

          const { registros } = respuesta;
          let listaProductos = false;
          if (registros.length > 0) {
            listaProductos = true;
          } else {
            listaProductos = false;
          }

          const data = {
            registros,
            listaProductos,
            mensajes,
          };
          //SI RESPUESTA ES TRUE EL PRODUCTO SI EXISTE EN OTRO DESCUENTO
          //SI ES FALSE EL PRODUCTO NO SE ENCUENTRA EN OTRO DESCUENTO
          resolve(data);
        });
      }, 1000);
    });

    return await Promise.resolve(a);
  }

  calcularPrecioFinal(producto) {
    let precioSinDescuento = producto.precio_unitario * 1; /*cantidad*/
    let precioFinal: number;

    if (producto.es_porcentaje == true) {
      precioFinal = precioSinDescuento - Math.round((precioSinDescuento * Number(producto.monto_descuento)) / 100);
      return precioFinal;
    } else if (producto.es_porcentaje == false) {
      const productMonto = producto.precio_fijo;
      precioFinal = precioSinDescuento - Number(productMonto);
      return precioFinal;
    }

    if (this.formDetails.get('tipoDescuento').value === '2') {
      // Descuento en porcentaje
      precioFinal = precioSinDescuento - Math.round((precioSinDescuento * Number(this.formDetails.get('montoOrPorcentaje').value.replace(',', '.'))) / 100);
      return precioFinal;
    } else if (this.formDetails.get('tipoDescuento').value === '1') {
      // Descuento en monto
      precioFinal = precioSinDescuento - Number(this.formDetails.get('montoOrPorcentaje').value);
      return precioFinal;
    } else {
      throw new Error('Tipo de descuento no válido. Debe ser "porcentaje" o "monto".');
    }
  }

  calcularDescuento(precioUnitario: number, descuento: number, tipoDescuento: string): number {
    if (tipoDescuento === '2') {
      // Descuento en porcentaje
      descuento = Number(this.formDetails.get('montoOrPorcentaje').value.replace(',', '.'));
      const descPorc = Math.round(precioUnitario * (descuento / 100));
      return descPorc;
    } else if (tipoDescuento === '1') {
      // Descuento en monto
      return descuento;
    } else {
      if (Boolean(tipoDescuento) == true) {
        descuento = Number(descuento);
        const descPorc = Math.round(precioUnitario * (descuento / 100));
        return descPorc;
      } else if (Boolean(tipoDescuento) == false) {
        return descuento;
      } else {
        throw new Error('Tipo de descuento no válido. Debe ser "porcentaje" o "monto".');
      }
    }
  }

  validateUnidadNegocioNewProduct({ unidad_negocio_codigo }): Boolean {
    if (!this.defaultUnidadNegocio) return true;
    return this.defaultUnidadNegocio === unidad_negocio_codigo;
  }

  fixAndDisableUnidadNegocio({ unidad_negocio_codigo }) {
    this.defaultUnidadNegocio = unidad_negocio_codigo; //this.formHeader.get("unidad_negocio_codigo").value
    // this.formHeader.get("unidad_negocio_codigo").setValue(unidad_negocio_codigo)
    // this.formHeader.get("unidad_negocio_codigo").disable()
  }

  renderItemDescuento() {
    // this.listaDescuentosPage = [...this.listaDescuentos]
    const from = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage;
    this.listaDescuentosPage = this.listaDescuentos.slice(from, from + this.paginationContext.RecordsByPage);
    this.paginationContext.RecordsCount = this.listaDescuentos.length;
    this.paginationContext.PagesCount = Math.ceil(this.listaDescuentos.length / this.paginationContext.RecordsByPage);
  }

  eliminarItemDescuento(index) {
    this.listaDescuentos = this.listaDescuentos.filter((item) => item.index !== index);
    this.modalConfirm.show(() => {
      this.toastrService.warning('producto eliminado');
      this.renderItemDescuento();
    });
  }

  hide() {
    this.listaDescuentosPage = [];
    this.EditarDesc = 0;
    this.EditoDesc = 0;
    this.btnGuardarDisabled = false;
    this.modalAgregarDescuento.hide();
    this.formHeader.get('descripcion').setValue('');
    this.formHeader.get('activo').setValue(true);
    this.formHeader.get('fechaInicio').setValue('');
    this.formHeader.get('fechaFin').setValue('');
    this.formDetails.get('montoOrPorcentaje').setValue('');
    this.reset();

    this.productosMultiplesSeleccionados = null;
  }

  /********* OPERATIONS *********/
  onPageChange(context: PaginationContext) {
    this.paginationContext.CurrentPage = context.RequestedPage;
    this.renderItemDescuento();
  }

  abrirModalSeleccionarProducto() {
    this.modalDescuento.showWithConfig({
      cleanData: true,
      showUnidadDeNegocioIfAllowed: true,
      defaultUnidadNegocio: this.defaultUnidadNegocio,
    });
  }

  abrirModalSeleccionarProductosSeleccionados() {
    this.modalDescuento.showSelected(this.productosMultiplesSeleccionados);
  }

  guardar() {
    this.formValidatorsService.validateAllFormFields(this.formHeader);
    if (!this.formHeader.valid) {
      this.toastrService.warning('Favor complete los datos requeridos');
      return;
    }

    if (this.EditoDesc == 0) {
      this.toastrService.warning('Favor presionar Check del producto para confirmar modificación.');
      return;
    }

    if (this.listaDescuentos.length == 0) {
      this.toastrService.warning('Favor corrija datos');
      return;
    }

    this.btnGuardarDisabled = true;

    let descuentoProductoMaximo: any = {
      cabecera: {
        codigo: this.codigoDescuento,
        sucursal_codigo: Number(this.sucursalEmpresa),
        rut_empresa: Number(this.rutEmpresa),
        fecha_inicio: this.formHeader.get('fechaInicio').value,
        fecha_termino: this.formHeader.get('fechaFin').value,
        activado: this.formHeader.get('activo').value,
        descripcion: this.formHeader.get('descripcion').value,
        rut_usuario: this.rutUsuario,
        editarDescFecha: this.mode,
        moduloGrabacion: 6
      },
      detalleProductos: [],
    };

    descuentoProductoMaximo.detalleProductos = this.listaDescuentos.map((producto) => ({
      sucursal_codigo: Number(this.sucursalEmpresa),
      rut_empresa: producto.empresa_rut,
      producto_codigo: producto.producto_codigo,
      skuProducto: producto.sku,
      es_porcentaje: producto.tipoDescuento === '2',
      monto_descuento: producto.tipoDescuento === '2' ? producto.porcentaje : 0,
      precio_fijo: producto.tipoDescuento === '2' ? 0 : producto.monto,
      descuento_codigo: this.codigoDescuento,
    }));

    const self = this;
    this.log('inputParams', JSON.stringify({ entidad: descuentoProductoMaximo }));

    this.gqlclient.mutate(
      {
        mutation: gql`
          mutation ($entidad: descuentoDTOMaximoInputType) {
            descuento_maximo {
              guardarDescuentoMaximo(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  cabecera {
                    sucursal_codigo
                    rut_empresa
                    codigo
                    descripcion
                    activado
                    fecha_inicio
                    fecha_termino
                  }
                  detalleProductos {
                    sucursal_codigo
                    rut_empresa
                    producto_codigo
                    es_porcentaje
                    monto_descuento
                    precio_fijo
                    descuento_codigo
                  }
                }
              }
            }
          }
        `,
        variables: {
          entidad: descuentoProductoMaximo,
        },
      },
      function (_respuesta) {
        const { mensajes, respuesta } = _respuesta.data.descuento_maximo.guardarDescuentoMaximo;

        //ERROR
        if (mensajes && mensajes.length > 0) {
          //Si existe un mensaje tipo error;

          const findError = mensajes.some((x) => x.tipo === 'ERROR');
          if (findError) {
            // self.messageRendererService.showErrors(mensajes, { positionClass: 'md-toast-top-center' })
            self.modalVerErrores.loadAndShow(mensajes);
            self.btnGuardarDisabled = false; // si existen al menos un error el btn no se desactiva.
            return;
          }

          //WARNING
          const findWarning = mensajes.some((x) => x.tipo === 'WARNING');
          if (findWarning) {
            self.modalVerErrores.loadAndShow(mensajes);
            self.btnGuardarDisabled = true; // si existen warning el btn se desactiva
            self.hide();
            self.onSuccess.emit();
            return;
          }
        } else {
          //SUCCESS
          self.toastrService.success('Descuento guardado');
          self.btnGuardarDisabled = true; // si estan todos los descuentos correctos el btn se desactiva
          self.hide();
          self.onSuccess.emit();
          return;
        }
      }
    );
  }

  onProductoSeleccionado({ data: _productoSeleccionado, origen }) {
    this.productosMultiplesSeleccionados = [];
    this.productosMultiplesSeleccionados.push(_productoSeleccionado);
    this.formDetails.get('codigoProducto').setValue(_productoSeleccionado.sku);
    // this.setCodigoProductoValidators('ADD')
  }

  onProductoNoEncontrado() {
    this.productosMultiplesSeleccionados = null;
  }

  onMultiplesProductosSeleccionados(data: IProductMultipleSelection) {
    this.log(data);
    this.productosMultiplesSeleccionados = data.data;
    if (data.data.length === 1) {
      this.formDetails.get('codigoProducto').setValue(data.data[0].sku);
      this.setCodigoProductoValidators('ADD');
    } else {
      this.formDetails.get('codigoProducto').setValue('');
      this.setCodigoProductoValidators('REMOVE');
    }
  }

  setCodigoProductoValidators(type: 'ADD' | 'REMOVE') {
    if (type === 'ADD') {
      this.formDetails.get('codigoProducto').setValidators([Validators.required, Validators.min(1)]);
    } else {
      this.formDetails.get('codigoProducto').setValidators([]);
    }
    this.formDetails.get('codigoProducto').updateValueAndValidity();
  }

  uncheckProducto(producto) {
    this.productosMultiplesSeleccionados = this.productosMultiplesSeleccionados.filter((p) => p.sku !== producto.sku);
    if (this.productosMultiplesSeleccionados.length === 0) this.productosMultiplesSeleccionados = null;
  }

  getProductsByUnidadNegocio({ inputParams, callback }) {
    if (this.permiteUnidadNegocio) {
      const innerInputParams = {
        entidad: {
          empresa_rut: inputParams.empresa_rut,
          sku: inputParams.sku,
          descripcion: inputParams.descripcion,
          tipobusqueda_estado: inputParams.tipobusqueda_estado,
          tipobusquedad_afecto_exento: inputParams.tipobusquedad_afecto_exento,
          listaFamilia: inputParams.familia,
          listaRubro: inputParams.rubro,
          unidad_negocio_codigo: inputParams.unidad_negocio_codigo ? inputParams.unidad_negocio_codigo : this.defaultUnidadNegocio,
        },
        paginaActual: inputParams.paginaActual,
        cantidadRegistrosPorPagina: inputParams.cantidadRegistrosPorPagina,
      };

      this.log('inputParams (Unidad Negocio)', JSON.stringify(inputParams));

      this.productoService.obtenerSegunFiltroProductosUnidadNegocio(innerInputParams, ({ respuesta, mensajes }) => {
        if (mensajes && mensajes.length > 0) {
          this.messageRendererService.showErrors(mensajes);
          return;
        }

        if (!respuesta) {
          callback(new QueryResult(null, 0, 0, 0));
          return;
        }
        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
        callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros));
      });
    } else {
      this.log('inputParams', JSON.stringify(inputParams));
      this.productoService.obtenerSegunFiltroProductos2(inputParams, ({ respuesta, mensajes }) => {
        if (mensajes && mensajes.length > 0) {
          this.messageRendererService.showErrors(mensajes);
          return;
        }

        if (!respuesta) {
          callback(new QueryResult(null, 0, 0, 0));
          return;
        }
        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
        callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros));
      });
    }
  }
}
